import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7089 12.3562V12.8218H11.2915V12.3562C11.2915 12.1682 11.3662 11.9879 11.4991 11.855C11.632 11.7221 11.8122 11.6475 12.0002 11.6475C12.1882 11.6475 12.3684 11.7221 12.5013 11.855C12.6342 11.9879 12.7089 12.1682 12.7089 12.3562Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.625 1.5H9C9.99456 1.5 10.9484 1.89509 11.6517 2.59835C12.3549 3.30161 12.75 4.25544 12.75 5.25V7.125C12.75 8.161 13.59 9 14.625 9H16.5C17.4946 9 18.4484 9.39509 19.1517 10.0983C19.8549 10.8016 20.25 11.7554 20.25 12.75V20.625C20.25 21.66 19.41 22.5 18.375 22.5H5.625C5.12772 22.5 4.65081 22.3025 4.29917 21.9508C3.94754 21.5992 3.75 21.1223 3.75 20.625V3.375C3.75 2.339 4.59 1.5 5.625 1.5ZM10.4384 10.7944C10.8526 10.3802 11.4144 10.1475 12.0002 10.1475C12.586 10.1475 13.1478 10.3802 13.562 10.7944C13.9762 11.2086 14.2089 11.7704 14.2089 12.3562V12.9114C14.4096 12.9846 14.594 13.1011 14.7479 13.2551C15.0253 13.5325 15.1812 13.9088 15.1812 14.3011V16.4892C15.1812 16.8815 15.0253 17.2578 14.7479 17.5352C14.4705 17.8127 14.0942 17.9685 13.7018 17.9685H10.2982C9.90585 17.9685 9.52957 17.8127 9.25214 17.5352C8.97471 17.2578 8.81885 16.8815 8.81885 16.4892V14.3011C8.81885 13.9088 8.97471 13.5325 9.25214 13.2551C9.40618 13.101 9.59069 12.9845 9.7915 12.9113V12.3562C9.7915 11.7704 10.0242 11.2086 10.4384 10.7944Z"
        fill={colorValue}
      />
      <path
        d="M14.25 5.25C14.2518 3.98855 13.7975 2.76896 12.971 1.816C14.6443 2.25596 16.1707 3.13247 17.3941 4.35589C18.6175 5.5793 19.494 7.10571 19.934 8.779C18.981 7.95248 17.7615 7.49825 16.5 7.5H14.625C14.5255 7.5 14.4302 7.46049 14.3598 7.39016C14.2895 7.31984 14.25 7.22446 14.25 7.125V5.25Z"
        fill={colorValue}
      />
    </svg>
  );
};
